<template>
    <div>
        <div class="tutorial-container" v-if="showTutorial">
            <div class="tutorial-content col-md-4">
                <div class="card tutorial-card">
                    <div class="card-header text-end d-flex justify-content-end">
                        <button class="btn btn-link text-white" @click="markTutorialAsShowed()"><i class="fa fa-xmark"></i></button>
                    </div>
                    <div class="card-body">
                        <h3 class="text-white">Bienvenida</h3>
                        <span>¡Te damos la bienvenida a Utel X for Business! Descubre herramientas innovadoras, recursos educativos y soluciones personalizadas para potenciar tu empresa.</span>
                    </div>
                    <!-- <div class="card-footer d-flex justify-content-end pb-3 pe-5 pt-2">
                        <a href="#" @click="markTutorialAsShowed(true)" class="text-end text-white">
                            Ver tutorial
                            <i class="fa ms-2 fa-arrow-right text-white"></i>
                        </a>
                    </div> -->
                </div>
            </div>
        </div>
        <informacion-general-component :issuperadmin="issuperadmin"
            :urldatacompany="urldatacompany"></informacion-general-component>

        <dashboard-graphics-component :issuperadmin="issuperadmin" :get="get" :urldatacompany="urldatacompany"
            :urldataclient="urldataclient" :urldataarea="urldataarea" :datagraphics="datagraphics"
            :urlstudentsdetail="urlstudentsdetail" :urltotalcourses="urltotalcourses" :urlplanesgrafica="urlplanesgrafica"
            :urltotalroutes="urltotalroutes" :urltotalplanes="urltotalplanes" :urltotalclients="urltotalclients"
            :urldataplanes="urldataplanes" :urldatacourses="urldatacourses" :urldataroutes="urldataroutes"
            :urldatastudents="urldatastudents" :urlroutesbytime="urlroutesbytime" :urlrankingbycourses="urlrankingbycourses" :allareas="allareas" :download="download"
            :go_to_learning="go_to_learning" :go_to_users="go_to_users" :showParentTutorial="showTutorial" :isOpenTutorial="openVideoModal">
        </dashboard-graphics-component>

        <dashboard-new-info-component :go_to_users="go_to_users"></dashboard-new-info-component>
        <show-bootcamps-component :urlbootcamps="urlbootcamps"></show-bootcamps-component>

        <!-- <modalVideo
            url="https://www.youtube.com/embed/1BA_FcheYec?si=ed3psim4Kz6ib0oS"
            v-if="openVideoModal"
            @onClose="openVideoModal = false"
        ></modalVideo> -->
    </div>
</template>

<script>
// import modalVideo from '../tutorials/ModalTutorial.vue';
export default {
    props: ["get", "urldatacompany", "urldataclient", "urldataarea", "datagraphics", "urlstudentsdetail", "urlplanesgrafica", "allareas", "urltotalcourses", "urltotalroutes", "urltotalplanes", "urltotalclients", "urldataplanes", "urldatastudents", "urldatacourses", "urldataroutes", "download", "urlbootcamps", "urlroutesbytime", "urlrankingbycourses", "go_to_users", "go_to_learning"],
    data: function () {
        return {
            issuperadmin: "false",
            showTutorial: false,
            openVideoModal: false
        }
    },
    mounted() {
        this.checkTutorialsShowed();
    },
    methods: {
        checkTutorialsShowed(){
            const tutorials = localStorage.getItem('showedtutorials') || null;
            if ( tutorials ) {
                const tutorialsArray = JSON.parse( tutorials );
                if (!tutorialsArray.includes('dashboard-admin')) {
                    this.showTutorial = true;
                }
            }else{
                this.showTutorial = true;
            }
        },
        markTutorialAsShowed(openVideo = false){
            const tutorials = localStorage.getItem('showedtutorials') || null;
            if ( tutorials ) {
                const currentTutorialsShowed = JSON.parse( tutorials );
                localStorage.setItem('showedtutorials', JSON.stringify([...currentTutorialsShowed, 'dashboard-admin']));
            }else{
                localStorage.setItem('showedtutorials',JSON.stringify(['dashboard-admin']));
            }

            this.showTutorial = false;

            if ( openVideo ) {
                this.openVideoModal = true;
            }
        }
    }
}
</script>

